/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Spanish (es) string table · skin-concerns.html
   English is the source of truth in the HTML; this file supplies the
   Spanish counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-es.js.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.es = window.TD_I18N.es || {};
  Object.assign(window.TD_I18N.es, {

    /* ── Page header ── */
    'concerns.headLabel': 'Encuentra tu fórmula',
    'concerns.headTitle': 'Empieza por lo que<br><em>te molesta.</em>',
    'concerns.headSub': 'Cinco sérums, cinco objetivos biológicos. Empieza por la necesidad que más te importa y, casi siempre, el sérum adecuado se elige solo.',

    /* ── Jump bar ── */
    'concerns.jumpLabel': 'Saltar a',
    'concerns.jumpFirmness': 'Firmeza',
    'concerns.jumpBrightness': 'Luminosidad',
    'concerns.jumpHydration': 'Hidratación',
    'concerns.jumpFineLines': 'Líneas finas',
    'concerns.jumpDarkSpots': 'Manchas oscuras',
    'concerns.jumpTexture': 'Textura',
    'concerns.jumpAcneScars': 'Cicatrices de acné',
    'concerns.jumpDullness': 'Falta de luminosidad',

    /* ── Reusable row labels ── */
    'concerns.startWith': 'Empieza con',
    'concerns.shopRoutine': 'Comprar esta rutina →',
    'concerns.nameC': 'Serum C — <em>Luminosidad</em>',
    'concerns.nameA': 'Serum A — <em>Renovación</em>',
    'concerns.nameO': 'Serum O — <em>Celular</em>',
    'concerns.nameM': 'Serum M — <em>Hidratación</em>',
    'concerns.nameR': 'Serum R — <em>Claridad</em>',
    'concerns.rolePrimaryDay': 'Principal · Día',
    'concerns.rolePrimaryNight': 'Principal · Noche',
    'concerns.rolePrimaryDayNight': 'Principal · Día + Noche',
    'concerns.roleLayerDay': 'Capa · Día',
    'concerns.roleLayerNight': 'Capa · Noche',

    /* ── Concern 01 · Firmness ── */
    'concerns.c1Num': 'Necesidad 01',
    'concerns.c1Title': 'Firmeza<br><em>y elasticidad.</em>',
    'concerns.c1Lede': 'La línea de la mandíbula se ablanda. Las mejillas pierden su elevación. La piel empieza a caer en lugar de sostenerse. Es la primera señal visible de que la producción de colágeno y elastina ha disminuido, y la más fácil de revertir a nivel celular.',

    /* ── Concern 02 · Brightness ── */
    'concerns.c2Num': 'Necesidad 02',
    'concerns.c2Title': 'Luminosidad<br><em>y daño solar.</em>',
    'concerns.c2Lede': 'La piel se ve apagada incluso cuando tú no lo estás. A menudo es acumulativo: UV, contaminación, estrés, energía celular reducida. La vitamina C es el ingrediente tópico más estudiado para la luminosidad. Serum O va más allá y alimenta las mitocondrias directamente, las células que producen energía.',

    /* ── Concern 03 · Hydration ── */
    'concerns.c3Num': 'Necesidad 03',
    'concerns.c3Title': 'Deshidratación<br><em>y pérdida de barrera.</em>',
    'concerns.c3Lede': 'La piel seca no es cuestión de más crema hidratante. Es cuestión de una barrera lipídica rota. La mayoría de cremas hidratantes son 65-85% agua más alcohol y conservantes, lo que paradójicamente reseca aún más la piel. Serum M reconstruye la barrera desde dentro con lípidos idénticos a los de la piel.',

    /* ── Concern 04 · Fine lines ── */
    'concerns.c4Num': 'Necesidad 04',
    'concerns.c4Title': 'Líneas finas<br><em>y arrugas.</em>',
    'concerns.c4Lede': 'Líneas superficiales por la expresión, pliegues más profundos por el tiempo y el sol. La renovación celular se ralentiza con la edad; los queratinocitos viejos se quedan más tiempo; la textura se resiente. El retinol impulsa la renovación y alisa la superficie; la vitamina C reconstruye la estructura por debajo.',

    /* ── Concern 05 · Dark spots ── */
    'concerns.c5Num': 'Necesidad 05',
    'concerns.c5Title': 'Manchas oscuras<br><em>y pigmentación.</em>',
    'concerns.c5Lede': 'El daño solar, los cambios hormonales y las marcas postinflamatorias concentran el pigmento en manchas desiguales. La vitamina C inhibe la enzima (tirosinasa) que impulsa la producción de pigmento; el resveratrol neutraliza los radicales libres que la desencadenan.',

    /* ── Concern 06 · Texture ── */
    'concerns.c6Num': 'Necesidad 06',
    'concerns.c6Title': 'Textura<br><em>irregular.</em>',
    'concerns.c6Lede': 'Zonas ásperas, poros visibles, una superficie desigual sobre la que el maquillaje se asienta en lugar de alisarla. Casi siempre es un problema de renovación celular: células viejas y engrosadas que permanecen más tiempo del que deberían. El retinol acelera el ciclo.',

    /* ── Concern 07 · Post-acne ── */
    'concerns.c7Num': 'Necesidad 07',
    'concerns.c7Title': 'Postacné<br><em>y cicatrices.</em>',
    'concerns.c7Lede': 'Mucho después de que el brote haya pasado, la marca a menudo sigue ahí. El resveratrol reduce la pigmentación postinflamatoria y acompaña a la piel mientras termina la reparación que empezó. Combina con Serum A por la noche para una renovación celular que acelere el desvanecimiento de la marca.',

    /* ── Concern 08 · Dullness / mature ── */
    'concerns.c8Num': 'Necesidad 08',
    'concerns.c8Title': 'Falta de luminosidad <em>&amp; pérdida de elasticidad.</em>',
    'concerns.c8Lede': 'A medida que la piel madura, los sistemas que la mantienen luminosa y firme se ralentizan. La claridad de la superficie se apaga y la elasticidad se afloja. Serum O renueva y revitaliza la piel madura a nivel celular, apoyando la luminosidad y la firmeza que disminuyen con la edad.',

    /* ── Not sure CTA ── */
    'concerns.unsureLabel': '¿Sigues eligiendo?',
    'concerns.unsureTitle': 'No elijas. Pruébalos los cinco.',
    'concerns.unsureBody': 'El Discovery Kit incluye versiones de tamaño bolsillo de cada sérum y una guía impresa. Es la forma más rápida de aprender cuál de tus necesidades responde a cada fórmula: en tu piel, no en la teoría.',
    'concerns.unsureBtn': 'Conseguir el Discovery Kit',

    /* ── Footer (page-specific extra) ── */
    'concerns.ftLearnRonlan': 'Sobre el Dr. Ronlán',

    /* ── Theme-only: Concern 08 alt framing (fatigue / low energy) ── */
    'concerns.c8TitleFatigue': 'Vitalidad reducida<br><em>y energía baja.</em>',
    'concerns.c8LedeFatigue': 'Una piel apagada no siempre es cuestión de lo que se ve en la superficie. Es cuestión de lo que la produce. La producción mitocondrial disminuye con la edad, y con ella, la capacidad de la célula para crear colágeno y reparar daños. Serum O alimenta el sistema directamente y devuelve energía a las células.',

    /* ── Theme-only: application banner (conditional) ── */
    'concerns.appDividerLabel': 'En la práctica',
    'concerns.appDividerQuote': 'Dos gotas, mañana y noche. La piel que tienes, atendida.',

    /* ── Theme-only: shortened unsure body (no printed guide) ── */
    'concerns.unsureBodyShort': 'El Discovery Kit incluye versiones de tamaño bolsillo de cada sérum. Es la forma más rápida de aprender cuál de tus necesidades responde a cada fórmula: en tu piel, no en la teoría.'

  });
})();
